import React from "react";
import "./Sections.scss";

function QAAdd() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          WHY IS THE STORY BEHIND YOUR JEWELRY IMPORTANT?
        </p>
        <p className="interview__interview__copy">
          Storytelling is at the heart of everything we do, from inspiration and
          design to fabrication. Storytelling is how we communicate with our
          customers. For example, every piece of Roberto Coin jewelry features a
          single ruby hidden inside, and that ruby is a message of goodwill to
          our clients.
        </p>
        <p className="interview__interview__copy">
          But even before it becomes my signature, the ruby itself has a story
          to tell. In fact, every single one of our jewels and materials has a
          story, and it is our mission to make sure that story is a positive
          one. That’s why we have a zero-tolerance policy towards conflict
          diamonds. That’s why we’re committed to keeping gold furnished by
          unethical producers out of our supply chains. We’ve been committed to
          ethical sourcing since day one. I’m very proud to tell that story with
          every piece of jewelry we create.
        </p>
      </div>
    </section>
  );
}

export default QAAdd;
